import { Switch, Route, useRouteMatch } from 'react-router-dom';
import LoadComponentWithRetry from '@/app/routes/LoadComponentWithRetry';

const ProfileComponent = LoadComponentWithRetry(() => import('./ProfilePage'));

const Routes = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}`} component={ProfileComponent} />
    </Switch>
  );
};

export default Routes;
